import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { UserContext } from '#providers/user/User.context.ts';
import type { TUserContextValue } from '#providers/user/User.types.ts';

export const useUser = (): TUserContextValue =>
  useRequiredContext(
    UserContext,
    'useUser is only available inside a UserProvider',
  );
